import React from 'react';

import { Helmet } from 'react-helmet';
import { graphql, useStaticQuery } from 'gatsby';
import _ from 'lodash';

import { Container } from 'constate';
import produce from 'immer';

import { authEffects } from '../app/effects/auth';

import individual from './img/np_user_197694_000000.png';
import business from './img/np_business_1019003_000000.png';

import Layout from '../components/layout';
import { PageTitle } from '../components/title';
import { Table, labelRow } from '../components/blocks/table';

const openAppStore = () => {
  window.open('https://itunes.apple.com/gb/app/switchsmith/id1194663008?mt=8');
}

const openPlayStore = () => {
  window.open('https://play.google.com/store/apps/details?id=com.relops.switchsmith&hl=en&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1');
}

const reducer = (acc, {type, best, payment, www, app, icon: { publicURL }}) => {
  return produce(acc, draft => {
    labelRow(draft, 'icon', publicURL, undefined, 0);
    labelRow(draft, 'type', `${type}`, 'Role', 1);
    labelRow(draft, 'payment', payment, 'Payment required', 2);
    labelRow(draft, 'best', best, 'Best for', 3);
    labelRow(draft, 'www', www, 'Sign up via website', 4);
    labelRow(draft, 'app', app, { url: '/download', label: 'Download apps' }, 5);
  });
};

const SignUp = ({register}) => {

  const { allOnboarding } = useStaticQuery(query);
  const { nodes: [{ accounts }]} = allOnboarding;

  const baseData = _.reduce(accounts, reducer, {});

  const data = {
    button: [6, false, undefined, undefined, {
      action: true,
      onClick: register,
      label: 'Create Account'
    }],
    ...baseData,
  };

  return (
    <div className="pb4">

      <Helmet title="Sign up for a business account | SwitchSmith">
        <link rel="canonical" href="https://switchsmith.com/signup" />
      </Helmet>

      <PageTitle title='Company Sign Up'/>

      <div className="row pt3 pb3">
        <div className="col-xs-1 col-sm-1 col-md-2 col-lg-2"></div>
        <div className="col-xs-10 col-sm-10 col-md-8 col-lg-8">
          <p className="f3-ns f4 tc">Create a billing account for your team</p>
        </div>
      </div>

      <Table data={data} bodyIdx={2} />

    </div>
  );
}

const SignUpPage = () => (
  <Layout>
    <Container
    context='primary'
    effects={authEffects}>
      {(props) => (
        <SignUp {...props} />
      )}
  </Container>
  </Layout>
)

export default SignUpPage;

export const query = graphql`
  query {
    allOnboarding {
      nodes {
        accounts {
          type
          www
          app
          best
          payment
          icon {
            publicURL
          }
        }
      }
    }
  }
`